import type { FC, ReactElement } from 'react';
import { Tooltip, TooltipTrigger, TooltipContent } from '../../components/tooltip';
import { useLocation } from 'react-router-dom';

type NavItemProps = {
  icon: ReactElement;
  text: string;
  isExpanded: boolean;
  notification?: number;
  href: string;
  navigate: (to: string) => void
};

const NavItem: FC<NavItemProps> = ({ icon, text, href, isExpanded, notification, navigate }) => {
  const location = useLocation();
  const isActive = href === '/' ? location.pathname === '/' : location.pathname.startsWith(href);
  
  const activeClass = isActive 
    ? 'bg-[#f0f0f0] text-black font-semibold' 
    : 'hover:bg-[#f0f0f0] text-[#444444] hover:text-black';

  const content = (
    <div className={`relative px-3 py-2.5 rounded-[2px] flex items-center gap-2 ${isExpanded ? 'justify-between' : 'justify-center'} text-sm cursor-pointer transition-colors duration-200 ${activeClass}`} onClick={() => navigate(href)}>
      <div className="flex items-center justify-center gap-2">
        <span>{icon}</span>
        {isExpanded && <div>{text}</div>}
      </div>
      {notification !== undefined && notification > 0 && (
        isExpanded ? (
          <span className="bg-black text-white rounded-[4px] px-2 py-0.5">
            {notification > 99 ? '99+' : notification}
          </span>
        ) : (
          <span className="absolute top-1 right-1 w-2.5 h-2.5 bg-red-500 rounded-full" />
        )
      )}
    </div>
  );

  if (!isExpanded) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          {content}
        </TooltipTrigger>
        <TooltipContent side="right" className="font-medium" sideOffset={8}>
          {text}
        </TooltipContent>
      </Tooltip>
    );
  }

  return content;
};

export default NavItem;
